var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZipcodeCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2469 2.75314C11.4177 2.924 11.4177 3.201 11.2469 3.37186L3.37186 11.2469C3.201 11.4177 2.924 11.4177 2.75314 11.2469C2.58229 11.076 2.58229 10.799 2.75314 10.6281L10.6281 2.75314C10.799 2.58229 11.076 2.58229 11.2469 2.75314Z",
    fill: "#1B1C1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75314 2.75314C2.924 2.58229 3.201 2.58229 3.37186 2.75314L11.2469 10.6281C11.4177 10.799 11.4177 11.076 11.2469 11.2469C11.076 11.4177 10.799 11.4177 10.6281 11.2469L2.75314 3.37186C2.58229 3.201 2.58229 2.924 2.75314 2.75314Z",
    fill: "#1B1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipcodeCloseIcon);
export default __webpack_public_path__ + "static/media/zipcode-close-icon.9a523c099a3af2af31539404e77848fd.svg";
export { ForwardRef as ReactComponent };